module.exports = __webpack_public_path__ + "static/media/V.89660f9c.jpg";